import isEmpty from 'lodash/isEmpty';

const defaultDuration = 2000;

const msgType = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
};

const action = {
  ADD: '추가',
  MODIFY: '수정',
  DELETE: '삭제',
  SAVE: '저장',
  APPLY: '적용',
  RELEASE: '해제',
  CHECK: '확인 처리',
  VIEW: '조회',
  SELECT: '선택',
  PROCESS: '처리',
  CANCEL: '취소',
  RUN: '실행',
  INPUT: '입력',
  SET: '설정',
  OUTPUT: '출력',
  ATTACH: '첨부',
  REGIST: '등록',
  EDIT: '편집',
};

const title = {
  CONFIRM: '확인',
  INFO: '정보',
};

const buttonText = {
  YES: '예',
  NO: '아니오',
  CONFIRM: '확인',
};

const finalEndings = {
  DECLARATIVE: '하였습니다.',
  DECLARATIVE_NEGATIVE: '하지 못하였습니다.',
  INTERROGATIVE: '하시겠습니까?',
  IMPERATIVE: '해주십시오.',
};

const defaultConfirmButton = {
  confirmButtonText: buttonText.YES,
  cancelButtonText: buttonText.NO,
  confirmButtonClass: 'el-button--solid',
};

/* private */
function getPostpositionOfValue(value, postpositionParam) {
  const lastChar = value.charCodeAt(value.length - 1);
  const hasFinalConsonant = (lastChar - 0xac00) % 28 > 0;

  let postposition;
  if (postpositionParam === '을' || postpositionParam === '를') {
    postposition = hasFinalConsonant ? '을' : '를';
  } else if (postpositionParam === '은' || postpositionParam === '는') {
    postposition = hasFinalConsonant ? '은' : '는';
  } else if (postpositionParam === '이' || postpositionParam === '가') {
    postposition = hasFinalConsonant ? '이' : '가';
  } else if (postpositionParam === '와' || postpositionParam === '과') {
    postposition = hasFinalConsonant ? '와' : '과';
  } else {
    postposition = '';
  }

  return postposition;
}

function getResultMsg(actionParam, target, successful) {
  const finalEndingsData = successful === true ? finalEndings.DECLARATIVE : finalEndings.DECLARATIVE_NEGATIVE;
  return `${target}${getPostpositionOfValue(target, '을')} ${actionParam}${finalEndingsData}`;
}

function getRequireInfoMsg(actionParam, target) {
  return `${target}${getPostpositionOfValue(target, '을')} ${actionParam}${finalEndings.IMPERATIVE}`;
}

/* confirm */
/**
 * 기본 confirm창의 메시지와 버튼 정보를 반환한다.
 * @author Ju
 * @param  {String} actionParam 액션명 (조회, 삭제, 수정, 저장 등. message util의 action 객체 참고)
 * @param  {String} titleParam  confirm창 타이틀. 기본은 '확인'
 * @return {Array}             [메시지, 타이틀, 버튼 객체]
 */
function getBasicConfirmData(actionParam, titleParam) {
  const message = actionParam + finalEndings.INTERROGATIVE;
  return [message, isEmpty(titleParam) ? title.CONFIRM : title, defaultConfirmButton];
}

function getCustomConfirmData(message, titleParam) {
  return [message, isEmpty(titleParam) ? title.CONFIRM : title, defaultConfirmButton];
}

/* result */
/**
 * 기본 결과 메시지 정보를 반환한다.
 * @author Ju
 * @param  {String} actionParam 액션명 (조회, 삭제, 수정, 저장 등. message util의 action 객체 참고)
 * @param  {String} target      액션 대상
 * @param  {Boolean} successful  성공 여부
 * @return {Object}             { message, type }
 *                              message: 결과 메시지, type: 성공 여부에 따라 success, error
 */
function getResultMsgData(actionParam, target, successful) {
  const message = getResultMsg(actionParam, target, successful);
  const type = successful === true ? msgType.SUCCESS : msgType.ERROR;
  return {
    message,
    type,
  };
}

/**
 * 커스텀 결과 메시지를 반환한다.
 * @author Ju
 * @param  {String} message    결과 메시지
 * @param  {Boolean} successful 성공 여부
 * @return {Object}             { message, type }
 *                              message: 결과 메시지, type: 성공 여부에 따라 success, error
 */
function getCustomResultMsgData(message, successful) {
  const type = successful === true ? msgType.SUCCESS : msgType.ERROR;
  return {
    message,
    type,
  };
}

/* info */
/**
 * 필수 정보에 대한 메시지를 반환한다.
 * @author Ju
 * @param  {String} actionParam 액션명 (조회, 삭제, 수정, 저장 등. message util의 action 객체 참고)
 * @param  {String} target      액션 대상
 * @return {Object}             { message, type }
 *                              message: 메시지, type: info
 */
function getRequireMsgData(actionParam, target) {
  const message = getRequireInfoMsg(actionParam, target);
  return {
    message,
    type: msgType.INFO,
  };
}

/**
 * 필수 정보에 대한 메시지를 반환한다.
 * @author Ju
 * @param  {String} message 메시지
 * @param  {String} target  액션 대상
 * @return {Object}         { message, type }
 *                           message: 메시지, type: info
 */
function getCustomMsgData(message) {
  return {
    message,
    type: msgType.INFO,
  };
}

export default {
  buttonText,
  msgType,
  action,
  defaultDuration,
  title,
  defaultConfirmButton,
  getBasicConfirmData,
  getCustomConfirmData,
  getResultMsg,
  getResultMsgData,
  getCustomResultMsgData,
  getRequireMsgData,
  getRequireInfoMsg,
  getCustomMsgData,
};



// WEBPACK FOOTER //
// ./src/utils/message.js